ArticleController.$inject = ['$rootScope', 'ArticleService', '$stateParams', 'AppService', '$uibModal', '$state', '$transitions']

export default function ArticleController($rootScope, ArticleService, $stateParams, AppService, $uibModal, $state, $transitions) {
  var vm = this

  function saveSelection() {
    if (window.getSelection) {
      sel = window.getSelection()
      if (sel.getRangeAt && sel.rangeCount) {
        var ranges = []
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          ranges.push(sel.getRangeAt(i))
        }
        return ranges
      }
    } else if (document.selection && document.selection.createRange) {
      return document.selection.createRange()
    }
    return null
  }

  var copy
  $rootScope.$watch('profile.id', profileId => {
    if (profileId !== undefined) {
      ArticleService.getArticle(profileId, $stateParams.slug).then(res => {
        vm.article = res.data
        copy = angular.copy(vm.article)
      })
    }
  })

  vm.insertLink = function() {
    AppService.savedSel = saveSelection()

    $uibModal.open({
      controller: 'ModalLinkController',
      controllerAs: 'modalLink',
      template: require('../../app/link-modal-new.html')
    }).result.then(angular.noop, angular.noop)
  }
  vm.setPromoted = function() {
    vm.article.isPromoted = !vm.article.isPromoted
  }
  vm.setPublished = function() {
    vm.article.isPublished = !vm.article.isPublished
  }
  vm.delete = function() {
    vm.confirmDelete = true
  }
  vm.doDelete = function() {
    vm.hideAlert('confirmDelete')
    ArticleService.deleteArticle(vm.article).then(() => $state.go('shell.articles'))
  }
  vm.hideAlert = function(alert) {
    vm[alert] = false
  }
  $transitions.onBefore({}, () => {
    if (!angular.equals(vm.article, copy)) return ArticleService.putArticle(vm.article)
  }, {invokeLimit: 1})
}